import {
    PageBuilderWidgetModel,
    PageBuilderTextPropertiesModel,
    PageBuilderIconPropertiesModel,
    PageBuilderContainerPropertiesModel,
    PageBuilderRowPropertiesModel,
    PageBuilderContactFormPropertiesModel,
    PageBuilderColumnPropertiesModel,
    PageBuilderVideoPlayerPropertiesModel
} from "@de-trustleap/shared-models";

import { TextWidget } from '../components/textWidget';
import { ImageWidget } from '../components/imageWidget';
import { IconWidget } from '../components/iconWidget';
import { ContainerWidget } from '../components/containerWidget';
import { RowWidget } from '../components/rowWidget';
import { ColumnWidget } from '../components/columnWidget';
import { FormWidget } from '../components/formWidget';
import { FooterWidget } from '../components/footerWidget';
import { VideoPlayerWidget } from '../components/videoPlayerWidget';
import { Logger } from '../utils/logger';

export class WidgetFactory {
    static async createWidget(widget: PageBuilderWidgetModel, isInsideRow: boolean = false): Promise<HTMLElement | null> {
        const props = widget.properties;
        try {
            switch (widget.elementType) {
                case 'text':
                    return new TextWidget(props as PageBuilderTextPropertiesModel).getWidget();

                case 'image':
                    return new ImageWidget(widget).getWidget();

                case 'icon':
                    return new IconWidget(props as PageBuilderIconPropertiesModel).getWidget();

                case 'container':
                    return new ContainerWidget(
                        props as PageBuilderContainerPropertiesModel,
                        widget.containerChild,
                        widget.padding ?? {},
                        widget.margin ?? {},
                        widget.background?.backgroundColor ?? 'transparent'
                    ).getWidget();
                    ;

                case 'row':
                    return new RowWidget(
                        props as PageBuilderRowPropertiesModel,
                        widget.children || [],
                        widget.maxWidth,
                        widget.padding || {},
                        widget.margin || {}
                    ).getWidget();

                case 'column':
                    return new ColumnWidget(
                        widget.children || [],
                        widget.maxWidth,
                        props as PageBuilderColumnPropertiesModel
                    ).getWidget();

                case 'contactForm':
                    return new FormWidget(
                        (props as PageBuilderContactFormPropertiesModel) ?? new PageBuilderContactFormPropertiesModel({})
                    ).createForm();

                case 'footer':
                    return new FooterWidget(widget).getWidget();

                case 'videoPlayer':
                    return new VideoPlayerWidget(props as PageBuilderVideoPlayerPropertiesModel).getWidget();

                default:
                    Logger.warn('⚠️ Unbekannter `elementType`:', widget.elementType);
                    return null;
            }
        } catch (error) {
            Logger.error('❌ Fehler beim Erstellen des Widgets:', {
                error,
                widget
            });
            return null;
        }
    }
}
